/* global jQuery:false Swiper:false */

/* eslint-disable */
webpackJsonp([1],{

/***/ 										13:
	/***/ (function(module, exports, __webpack_require__) {

		"use strict";


		var _hero = __webpack_require__(2);

		var _hero2 = _interopRequireDefault(_hero);

		var _storyFilter = __webpack_require__(59);

		var _storyFilter2 = _interopRequireDefault(_storyFilter);

		var _swiper = __webpack_require__(5);

		var _swiper2 = _interopRequireDefault(_swiper);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		// default hero transition
		(0, _hero2.default)("q-customers-hero");

		// target dropdowns and what particular data it should filter
		(0, _storyFilter2.default)("q-customers-story-filter--stories");
		(0, _storyFilter2.default)("q-customers-story-filter--size");
		(0, _storyFilter2.default)("q-customers-story-filter--industry");
		(0, _storyFilter2.default)("q-customers-story-filter--solution");

		/***/ }),

	/***/ 										33:
	/***/ (function(module, exports) {

		// removed by extract-text-webpack-plugin

		/***/ }),

	/***/ 										59:
	/***/ (function(module, exports, __webpack_require__) {

		"use strict";


		Object.defineProperty(exports, "__esModule", {
			value: true
		});
		/*

// Customers / Story filter

	Basic filter logic for the customers stories. It filters:
 - stories section (data-story)
 - solution item (data-solution)
 - industry item (data-industry)
 - size of item (data-size)

 It can filter multiple items with logical AND operation.

 Each item to be filtered, targeted by 'q-filter-item' has multiple data attributes for the filtering, i.e.
	<div .. data-size="size-smb" data-industry="industry-education" data-solution="solution-saq">

Each story section has data-story, i.e.
	<div class="q-customers-testimonials" data-story="testimonials" id="testimonials">

 These filter values (i.e. size-smb) are the same as on current production, but if needed to be changed they can
 be updated in /partials/customers/story-filter.hbs
 Note: If filter option values are updated, make sure they also match the values for the data they need to filter
*/

		function storyFilter(filterEl) {

			var dropdownElement = document.querySelectorAll("." + filterEl);
			var dropdownItems = Array.prototype.slice.call(dropdownElement, 0);

			var hideOpenMenus = function hideOpenMenus() {
				var dropdowns = document.getElementsByClassName("q-customers-story-filter__dropdown-menu");
				for (var i = 0; i < dropdowns.length; i++) {
					var openDropdown = dropdowns[i];
					if (!openDropdown.classList.contains("q-customers-story-filter__dropdown-menu--hidden")) {
						openDropdown.classList.add("q-customers-story-filter__dropdown-menu--hidden");
					}
				}
			};

			// update filters
			var updateFilters = function updateFilters() {
				var storyFilter = "";
				var sizeFilter = "";
				var industryFilter = "";
				var solutionFilter = "";

				var selectedFilter = document.querySelectorAll(".q-customers-story-filter__dropdown-item--selected");
				var filterItem = document.querySelectorAll(".q-filter-item");

				// set active filters
				for (var i = 0; i < selectedFilter.length; i++) {
					// story
					if (selectedFilter[i].dataset.type === "story") {
						storyFilter = selectedFilter[i].dataset.value;
					}

					//size
					if (selectedFilter[i].dataset.type === "size") {
						sizeFilter = selectedFilter[i].dataset.value;
					}

					//industry
					if (selectedFilter[i].dataset.type === "industry") {
						industryFilter = selectedFilter[i].dataset.value;
					}

					//solution
					if (selectedFilter[i].dataset.type === "solution") {
						solutionFilter = selectedFilter[i].dataset.value;
					}
				}

				// filtering for size, solution and industry
				filterItem.forEach(function (el) {
					var showItem = true;

					// filter size
					if (sizeFilter !== "all") {
						showItem = showItem && (el.dataset.size.indexOf(sizeFilter) > -1);
					}

					// filter solution
					if (solutionFilter !== "all") {
						showItem = showItem && (el.dataset.solution.indexOf(solutionFilter) > -1);
					}

					// filter solution
					if (industryFilter !== "all") {
						showItem = showItem && (el.dataset.industry.indexOf(industryFilter) > -1);
					}

					if (showItem) {
						el.removeAttribute("style");
					} else {
						el.style.display = "none";
					}
				});

				// filtering for stories 'sections'
				var storyType = document.querySelectorAll("[data-story]");
				for (var _i = 0; _i < storyType.length; _i++) {
					if (storyFilter !== "all") {
						if (storyType[_i].dataset.story === storyFilter) {
							storyType[_i].removeAttribute("style");
						} else {
							storyType[_i].style.display = "none";
						}
					} else {
						storyType[_i].removeAttribute("style");
					}
				}
			};

			dropdownItems.forEach(function (el) {
				var menuEl = el.querySelector(".q-customers-story-filter__dropdown-menu");
				var targetEl = el.querySelectorAll(".q-customers-story-filter__dropdown-select");
				var menuItems = el.querySelectorAll(".q-customers-story-filter__dropdown-item");

				// on click
				dropdownElement[0].addEventListener("click", function (e) {
					e.preventDefault();
					var dropdownItemTarget = e.target;

					hideOpenMenus();
					menuEl.classList.remove("q-customers-story-filter__dropdown-menu--hidden");

					if (menuEl.contains(dropdownItemTarget)) {
						// remove selected item from current dropdown and set text
						for (var i = 0; i < menuItems.length; i++) {
							menuItems[i].classList.remove("q-customers-story-filter__dropdown-item--selected");
						}
						dropdownItemTarget.classList.add("q-customers-story-filter__dropdown-item--selected");
						targetEl[0].children[0].textContent = dropdownItemTarget.textContent;

						// we manually trigger 'show all' on all sections
						var showAllButtons = document.querySelectorAll(".q-heading-plus-cta-button");
						for (var _i2 = 0; _i2 < showAllButtons.length; _i2++) {
							if (showAllButtons[_i2].dataset.show === "all") {
								showAllButtons[_i2].click();
							}
						}

						// run filter update
						updateFilters();

						// hide empty sections
						hideEmptySections();
					}
				});
			});

			function hideEmptySections() {
				// reset / unhide all sections
				var noResultsFound = document.querySelectorAll(".no-results-found")[0];
				noResultsFound.classList.add("hidden");

				var bestPracticeSection = document.querySelectorAll(".q-customers-practices")[0];
				var customersSuccessSection = document.querySelectorAll(".q-customers-success")[0];
				var customersTestimonials = document.querySelectorAll(".q-customers-testimonials")[0];
				bestPracticeSection.classList.remove("hidden");
				customersSuccessSection.classList.remove("hidden");
				customersTestimonials.classList.remove("hidden");

				// get items
				var bestPracticeItems = document.querySelectorAll(".q-customers-practice-item");
				var customersSuccessItems = document.querySelectorAll(".q-customers-case-studies__item");
				var customersTestimonialsItems = document.querySelectorAll(".q-customers-quotes__item");

				// convert collection to an array
				bestPracticeItems = Array.prototype.slice.call(bestPracticeItems, 0);
				customersSuccessItems = Array.prototype.slice.call(customersSuccessItems, 0);
				customersTestimonialsItems = Array.prototype.slice.call(customersTestimonialsItems, 0);

				// function to check if the array has visible items in it
				function hasVisible(items) {
					// function that returns true if element is visible, otherwise false
					function elementIsVisible( elem ) {
						return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
					}

					var hasVisible = false;
					for (var i=0; i<items.length; i++) {
						if (elementIsVisible(items[i])) {
							hasVisible = true;
							break;
						}
					}

					return hasVisible;
				}

				// if best practices section has no visible items
				if (!hasVisible(bestPracticeItems)) {
					// hide the best practices section
					bestPracticeSection.classList.add("hidden");
				}

				// if customer success story section has no visible items
				if (!hasVisible(customersSuccessItems)) {
					// hide the customer success story section
					customersSuccessSection.classList.add("hidden");
				}

				// if customer testimonial section has no visible items
				if (!hasVisible(customersTestimonialsItems)) {
					// hide the customer testimonial section
					customersTestimonials.classList.add("hidden");
				}

				if (bestPracticeSection.classList.contains("hidden") && 
			customersSuccessSection.classList.contains("hidden") && 
			customersTestimonials.classList.contains("hidden")) {
					noResultsFound.classList.remove("hidden");
				}

			}

			// Close the dropdown menu if the user clicks outside of it
			window.addEventListener("click", function (event) {
				if (!event.target.matches(".q-customers-story-filter__dropdown-title")) {
					hideOpenMenus();
				}
			});
		}

		exports.default = storyFilter;

		/***/ }),

	/***/ 										60:
	/***/ (function(module, exports, __webpack_require__) {

		"use strict";


		Object.defineProperty(exports, "__esModule", {
			value: true
		});

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		/***/ }),

	/***/ 										67:
	/***/ (function(module, exports, __webpack_require__) {

		__webpack_require__(13);
		module.exports = __webpack_require__(33);


		/***/ })

},[67]);
/* eslint-enable */


(function ($) {

	"use strict";

	// init customers carousel
	new Swiper(".swiper-container", {
		slidesPerView: "auto",
		autoHeight: false,
		centeredSlides: false,
		navigation: {
			nextEl: ".q-carousel-button--next",
			prevEl: ".q-carousel-button--prev",
			disabledClass: "q-carousel-button--disabled"
		},
		spaceBetween: 30
	});


	/*
	 * toggle show all / less
	 */
	$(".q-heading-plus-cta-button").on("click", function (event) {
		event.preventDefault();
		var show = $(event.currentTarget).attr("data-show");

		// determine type of story
		var classAttr = $(event.currentTarget).attr("class");
		var type = "";
		if (classAttr.indexOf("q-customers-practices") !== -1) {
			type = "q-customers-practices";
		} else if (classAttr.indexOf("q-customers-success") !== -1) {
			type = "q-customers-success";
		} else if (classAttr.indexOf("q-customers-testimonials") !== -1) {
			type = "q-customers-testimonials";
		}

		// show / hide stories
		if (show === "all") {
			$("." + type + " .q-filter-item--hidden").removeClass("q-filter-item--hidden");
			$(event.currentTarget).text("Show less").attr("data-show", "less");
		} else {
			$("." + type + " .q-filter-item:not(.q-filter-item--featured)").addClass("q-filter-item--hidden");
			$(event.currentTarget).text("Show all").attr("data-show", "all");
		}
	});

	/*
	 * auto select the business size menu based on url #hash value
	 */
	$(document).ready(function(){
		var sizeHash;
		if (window.location.hash) {
			/* Puts hash in variable, and removes the # character */
			sizeHash = window.location.hash.substring(1);
			/* remove initial slash if it exists */
			sizeHash = sizeHash.indexOf("/") == 0 ? sizeHash.substring(1) : sizeHash;
		}
		else {
			sizeHash = "";
		}
		if(sizeHash == "smb"){
			document.getElementsByClassName("js-q-customers__size--smb")[0].click();
		}
		else if(sizeHash == "sme"){
			document.getElementsByClassName("js-q-customers__size--sme")[0].click();
		}
		
	});

	/**
	 * open best practices, success stories, and testimonials sections based on hash value in the url
	 */

	function hashShowAll() {

		var hash = "";
		if (window.location.hash) {
			/* Puts hash in variable, and removes the # character */
			hash = window.location.hash.substring(1);
			/* remove initial slash if it exists */
			hash = hash.indexOf("/") == 0 ? hash.substring(1) : hash;

			if( hash === "best-practices" ){
				$( ".q-customers-practices__cta-button" ).trigger( "click" );
			}
			else if( hash === "success-stories" ){
				$( ".q-customers-success__cta-button" ).trigger( "click" );
			}
			else if( hash === "testimonials" ){
				$( ".q-customers-testimonials__cta-button" ).trigger( "click" );
			}
		}

	}
	//execute the function on document load
	$(document).ready(function () {
		hashShowAll();
	});
	//execute the function after the hash value changes in the url
	$( window ).on( "hashchange", function() {
		hashShowAll();
	});

}(jQuery));
